export enum IntegrationStateEnum {
  CONFIGURED = 'configured',
  DISABLED = 'disabled',
  NEEDS_CONFIGURATION = 'needs_configuration',
}
